import { useMatches } from 'react-router-dom'
import { crumbTrail, type Crumb } from '../lib/breadcrumbs'

/** The breadcrumb trail for the current route (see lib/breadcrumbs.ts) —
 * shared by Breadcrumbs and AppShell's crumb-bar spacing, so the route scheme
 * is read from the matched routes in one place. Needs a data router
 * (createBrowserRouter / createMemoryRouter). */
export function useCrumbTrail(): Crumb[] | null {
  return crumbTrail(useMatches())
}
